<div class="flex flex-col pt-16 gap-6 w-full max-w-[820px] mx-auto">
  <div class="flex flex-col text-center">
    <h1 class="text-[30px] font-medium leading-[45px] text-[#0a0a0a]">
      Zusammenfassung
    </h1>
    <p class="text-[16px] leading-[24px] text-[#717182]">
      Die folgenden Daten werden auf bildigsnetz.ch hinterlegt
    </p>
  </div>

  <app-school-summary-card
    [title]="summaryData().schoolName"
    [summary]="summaryData()"
    [institutionName]="getSelectedInstitutionName()" />

  <!-- Action Buttons -->
  <div class="flex w-full flex-wrap items-center justify-center gap-4 mt-8 mb-12">
    <button
      mat-stroked-button
      type="button"
      (click)="editProfile.emit()">
      Profil bearbeiten
    </button>
    <button
      mat-flat-button
      type="button"
      color="primary"
      (click)="createProfile.emit()"
      [disabled]="loading()">
      @if (loading()) {
        Wird erstellt…
      } @else if (role() === 'schulgemeinde') {
        Schulgemeindeprofil erstellen
      } @else {
        Speichern und Weiter
      }
    </button>
  </div>
</div>
